<div class="flex-content">
  <div class="make_dimmer"></div>
  <div class="content col-sm container-fluid">

    <!-- <div *ngFor="let key of datas | keys" class="row"> -->
    <div class="row">
      <div class="partners col-sm-12">
        <h2 class="partners-title col-sm-12">Government</h2>
        <div *ngFor="let partner of partners_government$ | async" class="partner-box col-sm-12 col-md-4 col-lg-3">
          <a [href]='partner.link' class="partner-img">
            <img default='./../../../../assets/Contents/imgs/no_image.jpg' [srcset]=" imgPath + partner.logo" [src]=" imgPath + partner.logo">
          </a>
          <p class="menu01 text-center">{{partner.name}}</p>
        </div>
      </div>
    </div>
    
    
    <div class="row">
      <div class="partners col-sm-12">
        <h2 class="partners-title col-sm-12">Institutions</h2>
        <div *ngFor="let partner of partners_institutions$ | async" class="partner-box col-sm-12 col-md-4 col-lg-3">
          <a [href]='partner.link' class="partner-img">
            <img default='./../../../../assets/Contents/imgs/no_image.jpg' [srcset]=" imgPath + partner.logo" [src]=" imgPath + partner.logo">
          </a>
          <p class="menu01 text-center">{{partner.name}}</p>
        </div>
      </div>
    </div>
    
    
    
    <div class="row">
      <div class="partners col-sm-12">
        <h2 class="partners-title col-sm-12">Academies</h2>
        <div *ngFor="let partner of partners_academies$ | async" class="partner-box col-sm-12 col-md-4 col-lg-3">
          <a [href]='partner.link' class="partner-img">
            <img default='./../../../../assets/Contents/imgs/no_image.jpg' [srcset]=" imgPath + partner.logo" [src]=" imgPath + partner.logo">
          </a>
          <p class="menu01 text-center">{{partner.name}}</p>
        </div>
      </div>
    </div>
    
    
    <div class="row">
      <div class="partners col-sm-12">
        <h2 class="partners-title col-sm-12">Productions</h2>
        <div *ngFor="let partner of partners_productions$ | async" class="partner-box col-sm-12 col-md-4 col-lg-3">
          <a [href]='partner.link' class="partner-img">
            <img default='./../../../../assets/Contents/imgs/no_image.jpg' [srcset]=" imgPath + partner.logo" [src]=" imgPath + partner.logo">
          </a>
          <p class="menu01 text-center">{{partner.name}}</p>
        </div>
      </div>
    </div>

  </div>
</div>


// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/about-partners/about-partners.component.html